export default __webpack_public_path__ + "static/media/me-icon-active.789b74ec.webp";